import GroupList from "../models/GroupList";

const GroupListStore = GroupList.create({
  groups: [],
  sortColumn: "createdAt",
  sortOrder: "descend"
});

export default GroupListStore;
